// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BuilderRouteImport } from './routes/builder'
import { Route as BulkRouteImport } from './routes/bulk'
import { Route as CleaningBuilderRouteImport } from './routes/cleaning-builder'
import { Route as ConstructionBuilderRouteImport } from './routes/construction-builder'
import { Route as ContractsRouteImport } from './routes/contracts'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DataSafetyRouteImport } from './routes/data-safety'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as EmployeeManagementRouteImport } from './routes/employee-management'
import { Route as EnterpriseApiDocsRouteImport } from './routes/enterprise-api-docs'
import { Route as EventBuilderRouteImport } from './routes/event-builder'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as HomeServicesBuilderRouteImport } from './routes/home-services-builder'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as LandscapingBuilderRouteImport } from './routes/landscaping-builder'
import { Route as OrgChartRouteImport } from './routes/org-chart'
import { Route as PestControlBuilderRouteImport } from './routes/pest-control-builder'
import { Route as PiBuilderRouteImport } from './routes/pi-builder'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as PowerWashingBuilderRouteImport } from './routes/power-washing-builder'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SalesInquiriesRouteImport } from './routes/sales-inquiries'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TeamRouteImport } from './routes/team'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ThreatsRouteImport } from './routes/threats'
import { Route as TimeAdminRouteImport } from './routes/time-admin'
import { Route as TimeClockRouteImport } from './routes/time-clock'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesCleaningRouteImport } from './routes/industries.cleaning'
import { Route as IndustriesConstructionServicesRouteImport } from './routes/industries.construction-services'
import { Route as IndustriesEventStaffingRouteImport } from './routes/industries.event-staffing'
import { Route as IndustriesFacilitiesMaintenanceRouteImport } from './routes/industries.facilities-maintenance'
import { Route as IndustriesHomeServicesRouteImport } from './routes/industries.home-services'
import { Route as IndustriesItManagedServicesRouteImport } from './routes/industries.it-managed-services'
import { Route as IndustriesLandscapingRouteImport } from './routes/industries.landscaping'
import { Route as IndustriesPestControlRouteImport } from './routes/industries.pest-control'
import { Route as IndustriesPowerWashingRouteImport } from './routes/industries.power-washing'
import { Route as IndustriesPrivateInvestigationRouteImport } from './routes/industries.private-investigation'
import { Route as IndustriesPropertyManagementRouteImport } from './routes/industries.property-management'
import { Route as IndustriesSecurityRouteImport } from './routes/industries.security'
import { Route as SignTokenRouteImport } from './routes/sign.$token'
import { Route as ThreatBuilderIndexRouteImport } from './routes/threat-builder.index'
import { Route as ThreatBuilderIdRouteImport } from './routes/threat-builder.$id'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BuilderRoute = BuilderRouteImport.update({
            id: '/builder',path: '/builder',getParentRoute: () => rootRouteImport
          })
const BulkRoute = BulkRouteImport.update({
            id: '/bulk',path: '/bulk',getParentRoute: () => rootRouteImport
          })
const CleaningBuilderRoute = CleaningBuilderRouteImport.update({
            id: '/cleaning-builder',path: '/cleaning-builder',getParentRoute: () => rootRouteImport
          })
const ConstructionBuilderRoute = ConstructionBuilderRouteImport.update({
            id: '/construction-builder',path: '/construction-builder',getParentRoute: () => rootRouteImport
          })
const ContractsRoute = ContractsRouteImport.update({
            id: '/contracts',path: '/contracts',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DataSafetyRoute = DataSafetyRouteImport.update({
            id: '/data-safety',path: '/data-safety',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const EmployeeManagementRoute = EmployeeManagementRouteImport.update({
            id: '/employee-management',path: '/employee-management',getParentRoute: () => rootRouteImport
          })
const EnterpriseApiDocsRoute = EnterpriseApiDocsRouteImport.update({
            id: '/enterprise-api-docs',path: '/enterprise-api-docs',getParentRoute: () => rootRouteImport
          })
const EventBuilderRoute = EventBuilderRouteImport.update({
            id: '/event-builder',path: '/event-builder',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const HomeServicesBuilderRoute = HomeServicesBuilderRouteImport.update({
            id: '/home-services-builder',path: '/home-services-builder',getParentRoute: () => rootRouteImport
          })
const InvoicesRoute = InvoicesRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => rootRouteImport
          })
const LandscapingBuilderRoute = LandscapingBuilderRouteImport.update({
            id: '/landscaping-builder',path: '/landscaping-builder',getParentRoute: () => rootRouteImport
          })
const OrgChartRoute = OrgChartRouteImport.update({
            id: '/org-chart',path: '/org-chart',getParentRoute: () => rootRouteImport
          })
const PestControlBuilderRoute = PestControlBuilderRouteImport.update({
            id: '/pest-control-builder',path: '/pest-control-builder',getParentRoute: () => rootRouteImport
          })
const PiBuilderRoute = PiBuilderRouteImport.update({
            id: '/pi-builder',path: '/pi-builder',getParentRoute: () => rootRouteImport
          })
const PortalRoute = PortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => rootRouteImport
          })
const PowerWashingBuilderRoute = PowerWashingBuilderRouteImport.update({
            id: '/power-washing-builder',path: '/power-washing-builder',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SalesInquiriesRoute = SalesInquiriesRouteImport.update({
            id: '/sales-inquiries',path: '/sales-inquiries',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const StaffRoute = StaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TeamRoute = TeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ThreatsRoute = ThreatsRouteImport.update({
            id: '/threats',path: '/threats',getParentRoute: () => rootRouteImport
          })
const TimeAdminRoute = TimeAdminRouteImport.update({
            id: '/time-admin',path: '/time-admin',getParentRoute: () => rootRouteImport
          })
const TimeClockRoute = TimeClockRouteImport.update({
            id: '/time-clock',path: '/time-clock',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
            id: '/admin/announcements',path: '/admin/announcements',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => rootRouteImport
          })
const IndustriesCleaningRoute = IndustriesCleaningRouteImport.update({
            id: '/industries/cleaning',path: '/industries/cleaning',getParentRoute: () => rootRouteImport
          })
const IndustriesConstructionServicesRoute = IndustriesConstructionServicesRouteImport.update({
            id: '/industries/construction-services',path: '/industries/construction-services',getParentRoute: () => rootRouteImport
          })
const IndustriesEventStaffingRoute = IndustriesEventStaffingRouteImport.update({
            id: '/industries/event-staffing',path: '/industries/event-staffing',getParentRoute: () => rootRouteImport
          })
const IndustriesFacilitiesMaintenanceRoute = IndustriesFacilitiesMaintenanceRouteImport.update({
            id: '/industries/facilities-maintenance',path: '/industries/facilities-maintenance',getParentRoute: () => rootRouteImport
          })
const IndustriesHomeServicesRoute = IndustriesHomeServicesRouteImport.update({
            id: '/industries/home-services',path: '/industries/home-services',getParentRoute: () => rootRouteImport
          })
const IndustriesItManagedServicesRoute = IndustriesItManagedServicesRouteImport.update({
            id: '/industries/it-managed-services',path: '/industries/it-managed-services',getParentRoute: () => rootRouteImport
          })
const IndustriesLandscapingRoute = IndustriesLandscapingRouteImport.update({
            id: '/industries/landscaping',path: '/industries/landscaping',getParentRoute: () => rootRouteImport
          })
const IndustriesPestControlRoute = IndustriesPestControlRouteImport.update({
            id: '/industries/pest-control',path: '/industries/pest-control',getParentRoute: () => rootRouteImport
          })
const IndustriesPowerWashingRoute = IndustriesPowerWashingRouteImport.update({
            id: '/industries/power-washing',path: '/industries/power-washing',getParentRoute: () => rootRouteImport
          })
const IndustriesPrivateInvestigationRoute = IndustriesPrivateInvestigationRouteImport.update({
            id: '/industries/private-investigation',path: '/industries/private-investigation',getParentRoute: () => rootRouteImport
          })
const IndustriesPropertyManagementRoute = IndustriesPropertyManagementRouteImport.update({
            id: '/industries/property-management',path: '/industries/property-management',getParentRoute: () => rootRouteImport
          })
const IndustriesSecurityRoute = IndustriesSecurityRouteImport.update({
            id: '/industries/security',path: '/industries/security',getParentRoute: () => rootRouteImport
          })
const SignTokenRoute = SignTokenRouteImport.update({
            id: '/sign/$token',path: '/sign/$token',getParentRoute: () => rootRouteImport
          })
const ThreatBuilderIndexRoute = ThreatBuilderIndexRouteImport.update({
            id: '/threat-builder/',path: '/threat-builder/',getParentRoute: () => rootRouteImport
          })
const ThreatBuilderIdRoute = ThreatBuilderIdRouteImport.update({
            id: '/threat-builder/$id',path: '/threat-builder/$id',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,BuilderRoute: BuilderRoute,BulkRoute: BulkRoute,CleaningBuilderRoute: CleaningBuilderRoute,ConstructionBuilderRoute: ConstructionBuilderRoute,ContractsRoute: ContractsRoute,DashboardRoute: DashboardRoute,DataSafetyRoute: DataSafetyRoute,DemoRoute: DemoRoute,EmployeeManagementRoute: EmployeeManagementRoute,EnterpriseApiDocsRoute: EnterpriseApiDocsRoute,EventBuilderRoute: EventBuilderRoute,HistoryRoute: HistoryRoute,HomeServicesBuilderRoute: HomeServicesBuilderRoute,InvoicesRoute: InvoicesRoute,LandscapingBuilderRoute: LandscapingBuilderRoute,OrgChartRoute: OrgChartRoute,PestControlBuilderRoute: PestControlBuilderRoute,PiBuilderRoute: PiBuilderRoute,PortalRoute: PortalRoute,PowerWashingBuilderRoute: PowerWashingBuilderRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SalesInquiriesRoute: SalesInquiriesRoute,SettingsRoute: SettingsRoute,StaffRoute: StaffRoute,SupportRoute: SupportRoute,TeamRoute: TeamRoute,TermsRoute: TermsRoute,ThreatsRoute: ThreatsRoute,TimeAdminRoute: TimeAdminRoute,TimeClockRoute: TimeClockRoute,AdminAnnouncementsRoute: AdminAnnouncementsRoute,IndustriesCleaningRoute: IndustriesCleaningRoute,IndustriesConstructionServicesRoute: IndustriesConstructionServicesRoute,IndustriesEventStaffingRoute: IndustriesEventStaffingRoute,IndustriesFacilitiesMaintenanceRoute: IndustriesFacilitiesMaintenanceRoute,IndustriesHomeServicesRoute: IndustriesHomeServicesRoute,IndustriesItManagedServicesRoute: IndustriesItManagedServicesRoute,IndustriesLandscapingRoute: IndustriesLandscapingRoute,IndustriesPestControlRoute: IndustriesPestControlRoute,IndustriesPowerWashingRoute: IndustriesPowerWashingRoute,IndustriesPrivateInvestigationRoute: IndustriesPrivateInvestigationRoute,IndustriesPropertyManagementRoute: IndustriesPropertyManagementRoute,IndustriesSecurityRoute: IndustriesSecurityRoute,SignTokenRoute: SignTokenRoute,ThreatBuilderIdRoute: ThreatBuilderIdRoute,AdminIndexRoute: AdminIndexRoute,IndustriesIndexRoute: IndustriesIndexRoute,ThreatBuilderIndexRoute: ThreatBuilderIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)